<template>
  <div class='cm-markdown' v-html='output' />
</template>

<script>
import marked from "marked";

export default {
  props: {
    input: {
      type: String
    }
  },

  computed: {
    output() {
      return marked(this.input);
    }
  }
};
</script>

<style lang='scss' scoped>
.cm-markdown {
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/markdown.vue?3318c192